import http from "./../../services/http";

export const layoutsPaginatedRequest = (page = 1, filter = "", categoryId) => {
  return http.get(
    `layouts?page=${page}${categoryId ? `&categoryId=${categoryId}` : ""}${
      filter.length > 0 ? `&name=${filter}` : ""
    }`
  );
};

export const layoutsMePaginatedRequest = (page = 1, filter = "", categoryId) => {
  return http.get(
    `layouts/all/me?page=${categoryId ? `&categoryId=${categoryId}` : ""}${
      filter.length > 0 ? `&name=${filter}` : ""
    }`
  );
};

export const layoutsShowRequest = (id) => {
  return http.get(`layouts/${id}`);
};

export const layoutsDeleteRequest = (id) => {
  return http.delete(`layouts/${id}`);
};

export const layoutsRestoreRequest = (id) => {
  return http.put(`layouts/${id}/restore`);
};

export const layoutsUpdateRequest = (payload) => {
  return http.put(`layouts/${payload.id}`, payload);
};

export const layoutsCreateRequest = (payload) => {
  return http.post(`layouts`, payload);
};

export const layoutFormatsByModelRequest = (layoutModelId) => {
  return http.get(`layout-formats/models/${layoutModelId}`);
};

export const layoutModelsRequest = () => {
  return http.get("layout-models");
};
